import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import logo from "../starworksLogoLong.png";
import { LinkContainer } from "react-router-bootstrap";
import { useEffect } from "react";
import { StarworksButton } from "./StarworksButton";

const Header = () => {
  useEffect(() => {
    document.title = "Starworks Studios";
  }, []);

  return (
    <Navbar
      expand="lg"
      className="color-header"
      data-bs-theme="dark"
      sticky="top"
    >
      <Container>
        <LinkContainer to="/">
          <Navbar.Brand>
            <img src={logo} className="Header-logo" alt="logo" />
          </Navbar.Brand>
        </LinkContainer>
        <span className="w10"></span>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
            <StarworksButton
              dropdown={[
                { label: "Boast Guards", to: "/games/BoastGuards" },
                { label: "BONED", to: "/games/BONED" },
                { label: "Timeworks", to: "/games/Timeworks" },
              ]}
            >
              Our Games
            </StarworksButton>
            <StarworksButton to="/blog">Blog</StarworksButton>
            <StarworksButton to="/team">About Us</StarworksButton>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;
